import React from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export const Problem = () => {
  const {
    t
  } = useLanguage();
  return <section className="py-8 md:py-16 bg-white" data-id="element-241">
      <div className="container mx-auto px-3 md:px-8" data-id="element-242">
        <div className="bg-blue-800 text-white py-2 md:py-3 px-4 md:px-6 rounded-t-lg inline-block mb-4 md:mb-8" data-id="element-243">
          <h2 className="text-base md:text-xl font-bold" data-id="element-244">
            {t('problem.header')}
          </h2>
        </div>
        <h3 className="text-xl md:text-3xl font-bold text-gray-800 mb-3 md:mb-4" data-id="element-245">
          {t('problem.title')}
        </h3>
        <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-8 italic" data-id="element-246">
          {t('problem.subtitle')}
        </p>
        <div className="bg-gray-50 p-4 md:p-8 rounded-lg shadow-md mb-6 md:mb-10" data-id="element-247">
          <h4 className="text-lg md:text-xl font-semibold mb-4 md:mb-6" data-id="element-248">
            {t('problem.issuesTitle')}
          </h4>
          <ul className="space-y-2 md:space-y-3" data-id="element-249">
            {[t('problem.issue1'), t('problem.issue2'), t('problem.issue3'), t('problem.issue4'), t('problem.issue5')].map((issue, index) => <li key={index} className="flex items-center" data-id="element-250">
                <span className="text-red-500 mr-2 md:mr-3" data-id="element-251">
                  <X size={18} data-id="element-252" />
                </span>
                <span className="text-sm md:text-base text-gray-700" data-id="element-253">
                  {issue}
                </span>
              </li>)}
          </ul>
        </div>
        <p className="text-base md:text-lg text-gray-700 mb-3 md:mb-4" data-id="element-254">
          {t('problem.text1')}
        </p>
        <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-8" data-id="element-255">
          {t('problem.text2')}
        </p>
        <p className="text-lg md:text-xl font-bold text-gray-900 mb-2" data-id="element-256">
          {t('problem.text3')}
        </p>
        <p className="text-lg md:text-xl font-bold text-gray-900 mb-4" data-id="element-257">
          {t('problem.text4')}
        </p>
      </div>
    </section>;
};